export default __webpack_public_path__ + "static/media/20_footer_order.baa26a97.png";